export default __webpack_public_path__ + "static/media/pdf_icon1.2cea8284.png";